import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IPlasiyerTeklifPage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPlasiyerTeklifPage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  GetPlasiyerTeklifTra: any[];
  GetPlasiyerTeklifTra_dummy: any[];
  GetTeklifMasPlasiyer: any[];
  GetTeklifMasPlasiyer_dummy: any[];
  HesaplaTeklifPlasiyer: any[];
  HesaplaTeklifPlasiyer_dummy: any[];
  GetTeklifGorusmeleri: any[];
  GetTeklifGorusmeleri_dummy: any[];
  UpdateTeklifTraTemp: number;
  UpdateTeklifTraTemp_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  InsertTeklifGorusmeleri: number;
  InsertTeklifGorusmeleri_dummy: number;
  YuzdeyiParayaCevirme: any[];
  YuzdeyiParayaCevirme_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  TeklifGenelIskontoUpdate: number;
  TeklifGenelIskontoUpdate_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  GetKullaniciMail: any[];
  GetKullaniciMail_dummy: any[];
  InsertTeklifHareketi: number;
  InsertTeklifHareketi_dummy: number;
  SendMail: boolean;
  SendMail_dummy: boolean;
  isComp391602Visible: "visible" | "hidden";
  isComp460928Enabled: "enabled" | "disabled";
  isComp567007Enabled: "enabled" | "disabled";
}

export class PlasiyerTeklifPage_ScreenBase extends React.PureComponent<
  IPlasiyerTeklifPage_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  plasiyerteklifpage_822839_value_kuikaTableRef: React.RefObject<any>;
  plasiyerteklifpage_689845_value_kuikaChatRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 952670,
          PropertyName: "value",
          Value: "Current Offer",
          TagName: "Label12_value",
        },
        {
          Id: 822839,
          PropertyName: "nodatafoundmessage",
          Value: "No Records Found to List",
          TagName: "Table0_nodatafoundmessage",
        },
        {
          Id: 477733,
          PropertyName: "label",
          Value: "Save Offer",
          TagName: "Button0_label",
        },
        {
          Id: 870948,
          PropertyName: "title",
          Value: "Picture",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 966292,
          PropertyName: "title",
          Value: "Code",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 483562,
          PropertyName: "title",
          Value: "Ordinary",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 667808,
          PropertyName: "title",
          Value: "Brand",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 465557,
          PropertyName: "title",
          Value: "Amount",
          TagName: "TableDefaultColumn2_title",
        },
        {
          Id: 439222,
          PropertyName: "title",
          Value: "Gross Price",
          TagName: "TableDefaultColumn1_title",
        },
        {
          Id: 205615,
          PropertyName: "title",
          Value: "Discount Rate",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 345727,
          PropertyName: "title",
          Value: "Net Price",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 174656,
          PropertyName: "title",
          Value: "Net Amount",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 751785,
          PropertyName: "value",
          Value: "Customer Request Number",
          TagName: "Label17_value",
        },
        {
          Id: 567007,
          PropertyName: "placeholder",
          Value: "Enter Request Number",
          TagName: "TextInput0_placeholder",
        },
        {
          Id: 364303,
          PropertyName: "value",
          Value: "Total Amount",
          TagName: "Label14_value",
        },
        {
          Id: 208784,
          PropertyName: "value",
          Value: "Discount",
          TagName: "Label14_value",
        },
        {
          Id: 942968,
          PropertyName: "value",
          Value: "Net Amount",
          TagName: "Label14_value",
        },
        {
          Id: 117427,
          PropertyName: "value",
          Value: "Kdv",
          TagName: "Label14_value",
        },
        {
          Id: 775291,
          PropertyName: "value",
          Value: "General Discount",
          TagName: "Label32_value",
        },
        {
          Id: 109062,
          PropertyName: "value",
          Value: "Grand Total",
          TagName: "Label14_value",
        },
        {
          Id: 336029,
          PropertyName: "value",
          Value: "Apply Special Discount",
          TagName: "Label35_value",
        },
        {
          Id: 82155597,
          PropertyName: "4738c88c-340d-aa57-8fef-218f28b4e945_notify",
          Value: "Transaction Successful",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 71071155,
          PropertyName: "3409feaa-5d5f-ad01-21c3-43cb948e862d_notify",
          Value: "Offer Saved Successfully",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 38617989,
          PropertyName: "8326ce5a-cffa-280c-01c3-dc34a3f3af08_notify",
          Value: "Email Sent Successfully",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 91860048,
          PropertyName: "887b3ba6-d0a5-bbda-6a5e-891d3d1c6ae3_notify",
          Value: "Discount Applied Successfully",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "4d04a400-baf0-4740-ac72-ce04c573c522",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 152908,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 966026, PropertyName: "label", Value: "Turkish" },
        { Id: 101507, PropertyName: "label", Value: "English" },
        { Id: 231438, PropertyName: "label", Value: "Spanish" },
        { Id: 305005, PropertyName: "label", Value: "French" },
        { Id: 4703, PropertyName: "label", Value: "Profil" },
        { Id: 952670, PropertyName: "value", Value: "Carinin Teklifi" },
        { Id: 616700, PropertyName: "value", Value: "Teklif Numarası" },
        {
          Id: 822839,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 870948, PropertyName: "title", Value: "Resim" },
        { Id: 966292, PropertyName: "title", Value: "Kod" },
        { Id: 487649, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 483562, PropertyName: "title", Value: "Adı" },
        { Id: 483118, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 667808, PropertyName: "title", Value: "Marka" },
        {
          Id: 519120,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 465557, PropertyName: "title", Value: "Miktar" },
        { Id: 958905, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 821212, PropertyName: "placeholder", Value: "15" },
        { Id: 439222, PropertyName: "title", Value: "Brut Fiyat" },
        { Id: 758174, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 309840, PropertyName: "placeholder", Value: "15" },
        { Id: 205615, PropertyName: "title", Value: "İskonto Oranı" },
        {
          Id: 801614,
          PropertyName: "value",
          Value: "[datafield:iskontooranlari]",
        },
        { Id: 345727, PropertyName: "title", Value: "Net Fiyat" },
        { Id: 417494, PropertyName: "value", Value: "[datafield:netfiyat]" },
        { Id: 174656, PropertyName: "title", Value: "Net Tutar" },
        { Id: 968634, PropertyName: "value", Value: "[datafield:nettutar]" },
        { Id: 640369, PropertyName: "value", Value: "Teklif Görüşmeleri" },
        { Id: 433858, PropertyName: "value", Value: "Sepet Bilgileri" },
        { Id: 751785, PropertyName: "value", Value: "Müşteri Talep No" },
        { Id: 567007, PropertyName: "placeholder", Value: "Talep No Giriniz" },
        { Id: 336029, PropertyName: "value", Value: "Özel İskonto Uygula" },
        { Id: 194277, PropertyName: "value", Value: "Ödeme Bilgileri" },
        { Id: 364303, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 208784, PropertyName: "value", Value: "İskonto" },
        { Id: 942968, PropertyName: "value", Value: "Net Tutar" },
        { Id: 117427, PropertyName: "value", Value: "Kdv" },
        { Id: 775291, PropertyName: "value", Value: "Genel İskonto" },
        { Id: 109062, PropertyName: "value", Value: "Genel Toplam" },
        { Id: 477733, PropertyName: "label", Value: "Teklif Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.plasiyerteklifpage_152908_value_kuikaTextInputRef = React.createRef();
    this.plasiyerteklifpage_822839_value_kuikaTableRef = React.createRef();
    this.plasiyerteklifpage_689845_value_kuikaChatRef = React.createRef();
    this.plasiyerteklifpage_567007_value_kuikaTextInputRef = React.createRef();
    this.plasiyerteklifpage_764658_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      IfThenElse: false,
      GetKullanici: [],
      GetCariBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetCariParaBirimi: [],
      GetPlasiyerTeklifTra: [],
      GetTeklifMasPlasiyer: [],
      HesaplaTeklifPlasiyer: [],
      GetTeklifGorusmeleri: [],
      UpdateTeklifTraTemp: 0,
      Notify: false,
      InsertTeklifGorusmeleri: 0,
      YuzdeyiParayaCevirme: [],
      SetValueOf: "",
      TeklifGenelIskontoUpdate: 0,
      TriggerEvent: "",
      GetKullaniciMail: [],
      InsertTeklifHareketi: 0,
      SendMail: false,
      isComp391602Visible: "hidden",
      isComp460928Enabled: "disabled",
      isComp567007Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "plasiyerteklifpage",
        "blank_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.PlasiyerTeklifPagePageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.PlasiyerTeklifPagePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "plasiyerteklifpage",
      "blank_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "plasiyerteklifpage",
      "blank_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PlasiyerTeklifPagePageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.PlasiyerTeklifPagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      plasiyerteklifpage_567007_value:
        this.state.GetTeklifMasPlasiyer?.at?.(0)?.talepNo ?? undefined,
      plasiyerteklifpage_51283_value:
        this.state.GetTeklifMasPlasiyer?.at?.(0)?.genelIskonto ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PlasiyerTeklifPagePageInit_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifPage",
      "PlasiyerHome",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PlasiyerTeklifPagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        null
      )
    ) {
      isErrorOccurred = await this.PlasiyerTeklifPagePageInit_if0();
      if (isErrorOccurred) return true;
    } else {
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerTeklifPagePageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PlasiyerTeklifPagePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      isPlasiyer_1: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      PlasiyerCariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      CariKod_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      paraBirimi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      cariKod_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      teklifNo_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      TeklifNumarasi_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      TeklifNumarasi_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      carikodu_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      teklifNumarasi_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPagePageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.plasiyerteklifpage_623753_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    formVars.plasiyerteklifpage_575970_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.plasiyerteklifpage_382735_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.plasiyerteklifpage_279691_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    formVars.plasiyerteklifpage_399646_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.plasiyerteklifpage_771480_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.plasiyerteklifpage_154822_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.plasiyerteklifpage_801976_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.plasiyerteklifpage_844496_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.plasiyerteklifpage_996125_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    stateVars.GetPlasiyerTeklifTra = result?.data.getPlasiyerTeklifTra;

    stateVars.GetTeklifMasPlasiyer = result?.data.getTeklifMasPlasiyer;
    formVars.plasiyerteklifpage_567007_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasPlasiyer !== undefined
        ? stateVars.GetTeklifMasPlasiyer?.length > 0
          ? stateVars.GetTeklifMasPlasiyer[0].talepNo
          : null
        : this.state.GetTeklifMasPlasiyer?.length > 0
        ? this.state.GetTeklifMasPlasiyer[0].talepNo
        : null
    );
    stateVars.HesaplaTeklifPlasiyer = result?.data.hesaplaTeklifPlasiyer;
    formVars.plasiyerteklifpage_314480_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamTutar
        : null
    );
    formVars.plasiyerteklifpage_573514_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
        : null
    );
    formVars.plasiyerteklifpage_695666_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].netTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].netTutar
        : null
    );
    formVars.plasiyerteklifpage_557251_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].kdvTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].kdvTutar
        : null
    );
    formVars.plasiyerteklifpage_854812_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelIskonto
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelIskonto
        : null
    );
    formVars.plasiyerteklifpage_514228_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelToplam
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelToplam
        : null
    );
    stateVars.isComp391602Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifPlasiyer !== undefined
            ? stateVars.HesaplaTeklifPlasiyer?.length > 0
              ? stateVars.HesaplaTeklifPlasiyer[0].genelIskonto
              : null
            : this.state.HesaplaTeklifPlasiyer?.length > 0
            ? this.state.HesaplaTeklifPlasiyer[0].genelIskonto
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetTeklifGorusmeleri = result?.data.getTeklifGorusmeleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerTeklifPagePageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPagePageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.plasiyerteklifpage_382735_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    formVars.plasiyerteklifpage_279691_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.plasiyerteklifpage_623753_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.plasiyerteklifpage_5578_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.plasiyerteklifpage_575970_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    stateVars.dataSource_822839 =
      stateVars.GetPlasiyerTeklifTra ?? this.state.GetPlasiyerTeklifTra;
    stateVars.isComp460928Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "plasiyerteklifpage_822839_value",
          "durumDeğeri"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.plasiyerteklifpage_766801_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.plasiyerteklifpage_122690_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.dataSource_689845 =
      stateVars.GetTeklifGorusmeleri ?? this.state.GetTeklifGorusmeleri;
    formVars.plasiyerteklifpage_567007_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetTeklifMasPlasiyer !== undefined
        ? stateVars.GetTeklifMasPlasiyer?.length > 0
          ? stateVars.GetTeklifMasPlasiyer[0].talepNo
          : null
        : this.state.GetTeklifMasPlasiyer?.length > 0
        ? this.state.GetTeklifMasPlasiyer[0].talepNo
        : null
    );

    formVars.plasiyerteklifpage_51283_value = ReactSystemFunctions.value(
      this,
      stateVars.GetTeklifMasPlasiyer !== undefined
        ? stateVars.GetTeklifMasPlasiyer?.length > 0
          ? stateVars.GetTeklifMasPlasiyer[0].genelIskonto
          : null
        : this.state.GetTeklifMasPlasiyer?.length > 0
        ? this.state.GetTeklifMasPlasiyer[0].genelIskonto
        : null
    );

    formVars.plasiyerteklifpage_399646_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.plasiyerteklifpage_314480_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamTutar
        : null
    );

    formVars.plasiyerteklifpage_771480_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.plasiyerteklifpage_573514_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
        : null
    );

    formVars.plasiyerteklifpage_154822_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.plasiyerteklifpage_695666_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].netTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].netTutar
        : null
    );

    formVars.plasiyerteklifpage_801976_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.plasiyerteklifpage_557251_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].kdvTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].kdvTutar
        : null
    );

    stateVars.isComp391602Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifPlasiyer !== undefined
            ? stateVars.HesaplaTeklifPlasiyer?.length > 0
              ? stateVars.HesaplaTeklifPlasiyer[0].genelIskonto
              : null
            : this.state.HesaplaTeklifPlasiyer?.length > 0
            ? this.state.HesaplaTeklifPlasiyer[0].genelIskonto
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerteklifpage_844496_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.plasiyerteklifpage_854812_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelIskonto
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelIskonto
        : null
    );

    formVars.plasiyerteklifpage_996125_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.plasiyerteklifpage_514228_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelToplam
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_152908_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifpage_152908_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifPage",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_217727_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifPage",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_562829_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifPage",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "406188",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_966026_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_101507_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_231438_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_305005_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_4703_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifPage",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_822839_onRowEditFinished = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_822839_birimFiyat",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_822839_miktar",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerteklifpage_822839_value",
          ".id"
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPageComponent_822839_onRowEditFinished",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateTeklifTraTemp = result?.data.updateTeklifTraTemp;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_822839_onRowEditFinished1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_822839_onRowEditFinished1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "4738c88c_340d_aa57_8fef_218f28b4e945_notify",
        this.defaultML,
        "İşlem Başarılı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_822839_onRowEditFinished2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_822839_onRowEditFinished2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      cariKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      teklifNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      TeklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      carikodu_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPageComponent_822839_onRowEditFinished2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetPlasiyerTeklifTra = result?.data.getPlasiyerTeklifTra;

    stateVars.HesaplaTeklifPlasiyer = result?.data.hesaplaTeklifPlasiyer;
    formVars.plasiyerteklifpage_314480_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamTutar
        : null
    );
    formVars.plasiyerteklifpage_573514_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
        : null
    );
    formVars.plasiyerteklifpage_695666_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].netTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].netTutar
        : null
    );
    formVars.plasiyerteklifpage_557251_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].kdvTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].kdvTutar
        : null
    );
    formVars.plasiyerteklifpage_854812_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelIskonto
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelIskonto
        : null
    );
    formVars.plasiyerteklifpage_514228_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelToplam
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelToplam
        : null
    );
    stateVars.isComp391602Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifPlasiyer !== undefined
            ? stateVars.HesaplaTeklifPlasiyer?.length > 0
              ? stateVars.HesaplaTeklifPlasiyer[0].genelIskonto
              : null
            : this.state.HesaplaTeklifPlasiyer?.length > 0
            ? this.state.HesaplaTeklifPlasiyer[0].genelIskonto
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_822839_onRowEditFinished3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_822839_onRowEditFinished3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_822839 =
      stateVars.GetPlasiyerTeklifTra ?? this.state.GetPlasiyerTeklifTra;
    formVars.plasiyerteklifpage_314480_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamTutar
        : null
    );

    formVars.plasiyerteklifpage_573514_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].toplamIskontoTutar
        : null
    );

    formVars.plasiyerteklifpage_695666_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].netTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].netTutar
        : null
    );

    formVars.plasiyerteklifpage_557251_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].kdvTutar
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].kdvTutar
        : null
    );

    formVars.plasiyerteklifpage_854812_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelIskonto
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelIskonto
        : null
    );

    formVars.plasiyerteklifpage_514228_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifPlasiyer !== undefined
        ? stateVars.HesaplaTeklifPlasiyer?.length > 0
          ? stateVars.HesaplaTeklifPlasiyer[0].genelToplam
          : null
        : this.state.HesaplaTeklifPlasiyer?.length > 0
        ? this.state.HesaplaTeklifPlasiyer[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_609493_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Resimler",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyerteklifpage_822839_value",
          "stokKodu"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifPage",
      "Resimler",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "908913",
      null,
      null,
      "true",
      "600px",
      "600px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_689845_onMessageSend = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Mesaj_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifpage_689845_value",
            "message",
            "GetTeklifGorusmeleri",
            "",
            ""
          )
        ),
        "string"
      ),
      KullaniciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      teklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPageComponent_689845_onMessageSend",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InsertTeklifGorusmeleri = result?.data.insertTeklifGorusmeleri;
    stateVars.GetTeklifGorusmeleri = result?.data.getTeklifGorusmeleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_689845_onMessageSend1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_689845_onMessageSend1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_689845 =
      stateVars.GetTeklifGorusmeleri ?? this.state.GetTeklifGorusmeleri;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_51283_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      yuzde_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifpage_51283_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      genelToplam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifPlasiyer !== undefined
            ? stateVars.HesaplaTeklifPlasiyer?.length > 0
              ? stateVars.HesaplaTeklifPlasiyer[0].toplamTutar
              : null
            : this.state.HesaplaTeklifPlasiyer?.length > 0
            ? this.state.HesaplaTeklifPlasiyer[0].toplamTutar
            : null
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPageComponent_51283_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuzdeyiParayaCevirme = result?.data.yuzdeyiParayaCevirme;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_51283_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_51283_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "plasiyerteklifpage_764658_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.YuzdeyiParayaCevirme !== undefined
          ? stateVars.YuzdeyiParayaCevirme?.length > 0
            ? stateVars.YuzdeyiParayaCevirme[0].paraCinsi
            : null
          : this.state.YuzdeyiParayaCevirme?.length > 0
          ? this.state.YuzdeyiParayaCevirme[0].paraCinsi
          : null
      ),
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_360849_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      genelisk_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifpage_51283_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      teklifno_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPageComponent_360849_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifGenelIskontoUpdate = result?.data.teklifGenelIskontoUpdate;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_360849_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_360849_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "887b3ba6_d0a5_bbda_6a5e_891d3d1c6ae3_notify",
        this.defaultML,
        "İskonto Başarıyla Uygulandı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    await this.PlasiyerTeklifPagePageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifPageComponent_477733_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ıd_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeklifMasPlasiyer !== undefined
            ? stateVars.GetTeklifMasPlasiyer?.length > 0
              ? stateVars.GetTeklifMasPlasiyer[0].kullaniciID
              : null
            : this.state.GetTeklifMasPlasiyer?.length > 0
            ? this.state.GetTeklifMasPlasiyer[0].kullaniciID
            : null
        ),
        "number"
      ),
      siraNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeklifMasPlasiyer !== undefined
            ? stateVars.GetTeklifMasPlasiyer?.length > 0
              ? stateVars.GetTeklifMasPlasiyer[0].revizeSiraNo
              : null
            : this.state.GetTeklifMasPlasiyer?.length > 0
            ? this.state.GetTeklifMasPlasiyer[0].revizeSiraNo
            : null
        ),
        "number"
      ),
      plasiyer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].adSoyad
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].adSoyad
            : null
        ),
        "string"
      ),
      TeklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      genelToplam_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifPlasiyer !== undefined
            ? stateVars.HesaplaTeklifPlasiyer?.length > 0
              ? stateVars.HesaplaTeklifPlasiyer[0].genelToplam
              : null
            : this.state.HesaplaTeklifPlasiyer?.length > 0
            ? this.state.HesaplaTeklifPlasiyer[0].genelToplam
            : null
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPageComponent_477733_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullaniciMail = result?.data.getKullaniciMail;
    stateVars.InsertTeklifHareketi = result?.data.insertTeklifHareketi;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_477733_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_477733_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "3409feaa_5d5f_ad01_21c3_43cb948e862d_notify",
        this.defaultML,
        "Teklif Başarıyla Kaydedildi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_477733_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_477733_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "a1c15e6e-7882-4cf1-8568-020c5a33ae1d",
          "string"
        ),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullaniciMail !== undefined
            ? stateVars.GetKullaniciMail?.length > 0
              ? stateVars.GetKullaniciMail[0].kullaniciKodu
              : null
            : this.state.GetKullaniciMail?.length > 0
            ? this.state.GetKullaniciMail[0].kullaniciKodu
            : null
        ),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Teklif Refize Detayları",
          "string"
        ),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      cc_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      bcc_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      language_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      MusteriAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_ISIM
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_ISIM
            : null
        ),
        "string"
      ),
      TeklifNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNo ?? this.props.screenInputs.teklifno,
        "string"
      ),
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("08.01.2025", "string"),
        "string"
      ),
      PlasiyerAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].adSoyad
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].adSoyad
            : null
        ),
        "string"
      ),
      plasiyerMail_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].kullaniciKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].kullaniciKodu
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifPage/PlasiyerTeklifPageComponent_477733_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifPageComponent_477733_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifPageComponent_477733_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8326ce5a_cffa_280c_01c3_dc34a3f3af08_notify",
        this.defaultML,
        "Mail Başarıyla Gönderildi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifPage",
      "PlasiyerHome",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , , 406188, , 908913] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PlasiyerTeklifPagePageInit();
    }
  }
}
